/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type VariationTool = {
  /**
   * The key of the tool to use.
   */
  key: string;
  /**
   * The version of the tool.
   */
  version: number;
  /**
   * Custom metadata and configuration for application-level use
   */
  customParameters?: { [k: string]: any } | undefined;
};

/** @internal */
export const VariationTool$inboundSchema: z.ZodType<
  VariationTool,
  z.ZodTypeDef,
  unknown
> = z.object({
  key: z.string(),
  version: z.number().int(),
  customParameters: z.record(z.any()).optional(),
});
/** @internal */
export type VariationTool$Outbound = {
  key: string;
  version: number;
  customParameters?: { [k: string]: any } | undefined;
};

/** @internal */
export const VariationTool$outboundSchema: z.ZodType<
  VariationTool$Outbound,
  z.ZodTypeDef,
  VariationTool
> = z.object({
  key: z.string(),
  version: z.number().int(),
  customParameters: z.record(z.any()).optional(),
});

export function variationToolToJSON(variationTool: VariationTool): string {
  return JSON.stringify(VariationTool$outboundSchema.parse(variationTool));
}
export function variationToolFromJSON(
  jsonString: string,
): SafeParseResult<VariationTool, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VariationTool$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VariationTool' from JSON`,
  );
}
